<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            {{$t('form.recherche-ticket.identification_du_ticket_de_caisse')}}
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <template v-if="selected">
                    <span class="font-bold" v-if="selected.hasTicket == true && !selected.found">
                        {{$t('form.recherche-ticket.ticket_de_caisse_introuvable')}}
                    </span>
                    <span class="font-bold" v-if="selected.hasTicket == false">
                        {{$t('form.recherche-ticket.je_ne_possede_pas_de_ticket_de_caisse')}}
                    </span>
                    <span class="font-bold" v-if="selected.end == true">
                        {{selected.device.description}}
                    </span>
                </template>
            </template>

            <template v-slot:open>
                <template v-if="findTicket">
                    <!-- User have ticket -->
                    <template v-if="findTicket.hasTicket === null || findTicket.hasTicket === false">
                        <div class="mb-2">{{$t('form.recherche-ticket.possedez_vous_votre_ticket_de_caisse_?')}}</div>
                        <div class="flex items-center">
                            <button @click="confirmHasTicket" class="mr-2 px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-green-600 border-green-700 hover:bg-green-700 rounded-xl" test-id="sav-button">
                                {{$t('form.recherche-ticket.oui')}} <i class="fas fa-check ml-1"></i>
                            </button>
                            <button @click="confirmHasnTicket" class="px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-red-400 border-red-500 hover:bg-red-500 rounded-xl" test-id="sav-button">
                                {{$t('form.recherche-ticket.non')}} <i class="fas fa-times ml-1"></i>
                            </button>
                        </div>
                    </template>

                    <!-- Search ticket -->
                    <template v-if="findTicket.hasTicket == true && findTicket.found == null">
                        <sav-input v-model="findTicket.date" type="date" :label="$t('form.recherche-ticket.a_quelle_date_avez_vous_achete_votre_produit_?')" :min="dateRange.min" :max="dateRange.max" class="mb-4" />
                        <sav-input v-model="findTicket.codeCaisse" type="text" :label="$t('form.recherche-ticket.code_caisse_indique_sur_le_ticket')" class="mb-4" />
                        <sav-input v-model="findTicket.numeroTicket" type="text" :label="$t('form.recherche-ticket.numero_de_ticket_de_caisse')" class="mb-4" />
                        <label for="get-shop" class="block pb-2 font-light text-gray-600">{{$t('form.recherche-ticket.magasin')}}</label>
                        <div v-if="!findTicket.shop" class="bg-gray-50 p-4 rounded-xl border border-gray-300 text-gray-900 text-sm mb-4">
                            <sav-input
                            id="get-shop"
                            type="sav-select"
                            v-model="findTicket.shop"
                            label="test"
                            class="mb-4"
                            :options="{
                                label: 'townAndZipCode',
                                values: shops,
                                required: true
                            }"
                            />
                        </div>
                        <div v-else class="mb-4 bg-gray-50 items-center justify-between p-4 border border-gray-300 my-rounded md:flex text-sm">
                            <div class="font-bold">
                                <div>{{findTicket.shop.townAndZipCode}}</div>
                            </div>
                            <button class="p-2.5 px-4 pr-3 mt-2 text-xs font-light text-white duration-200 bg-red-400 rounded-xl cursor-pointer md:mt-0 hover:bg-red-500" @click="findTicket.shop = null">
                                <i class="mr-0.5 fas fa-times"></i> Annuler
                            </button>
                        </div>
                        <button v-if="!loadingApiTicket" @click="searchApiTicket" class="px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-green-600 border-green-700 hover:bg-green-700 rounded-xl" test-id="sav-button">
                            <i class="mr-1 fas fa-check"></i> {{$t('composants.form.valider')}}
                        </button>
                        <sav-spinner v-if="loadingApiTicket" />
                    </template>
                    <template v-if="findTicket.found !== null && findTicket.found == false">
                        <div class="text-red-600 font-bold text-lg"><i class="fas fa-times mr-1"></i> {{$t('form.recherche-ticket.ticket_de_caisse_introuvable')}}</div>
                        <hr class="my-2">
                        <p class="font-light text-lg mb-2">{{$t('form.recherche-ticket.que_souhaitez_vous_faire_?')}}</p>
                        <button @click="searchRetry" class="px-5 py-2.5 text-sm font-base duration-100 duration-200 bg-gray-300 border-gray-400 rounded-xl" test-id="sav-button">
                            {{$t('form.recherche-ticket.corriger_mes_informations')}} <i class="fas fa-edit ml-1"></i>
                        </button>
                        <button @click="getManually" class="mr-2 px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-green-600 border-green-700 hover:bg-green-700 rounded-xl" test-id="sav-button">
                            {{$t('form.recherche-ticket.rechercher_mon_produit_autrement')}} <i class="fas fa-search ml-1"></i>
                        </button>
                    </template>
                    <template v-if="findTicket.found !== null && findTicket.found == true">
                        <div class="text-green-600 font-bold text-lg"><i class="fas fa-check mr-1"></i> {{$t('form.recherche-ticket.ticket_de_caisse_identifie')}}</div>
                        <hr class="my-2 mb-5">
                        <template v-if="!findTicket.device">
                            <label for="get-shop" class="block pb-2 font-light text-gray-600">{{$t('form.recherche-ticket.selectionner_votre_produit')}} :</label>
                            <div @click="product.id && product.id != '0' ? (findTicket.device = product) : $toast.warning('Cet article ne peut pas être séléctionné')" v-for="(product, i) in products" :key="'product-' + i" class="border rounded-xl p-4 py-6 mb-2" :class="product.id && product.id != '0' ? 'cursor-pointer hover:bg-gray-50' : 'cursor-no-drop bg-red-50 border-red-50'">
                                <div class="flex items-center justify-between">
                                    <div :class="product.id && product.id != '0' ? 'font-bold' : 'font-light text-sm'">{{product.description}}</div>
                                    <div class="text-sm font-light">{{product.prix}}€</div>
                                </div>
                            </div>
                        </template>

                        <template v-if="findTicket.device && !findTicket.end">
                            <sav-input v-model="findTicket.img_plaque_signaletique" type="file" :label="$t('form.recherche-ticket.photo_de_la_plaque_signaletique')" class="mb-4" />
                            <button @click="sendFiles" class="px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-green-600 border-green-700 hover:bg-green-700 rounded-xl" test-id="sav-button">
                                <i class="mr-1 fas fa-check"></i> {{$t('composants.form.valider')}}
                            </button>
                        </template>
                        <template v-if="findTicket.end !== null">
                            <label for="get-shop" class="block pb-2 font-light text-gray-600">{{$t('form.recherche-ticket.ticket')}}</label>
                            <div class="p-4 bg-gray-50 mb-4 rounded-xl border">
                                <div v-if="findTicket.date" class="mb-4">
                                    <div class="font-light">{{$t('form.recherche-ticket.date')}}:</div>
                                    <b>{{findTicket.date}}</b>
                                </div>
                                <div v-if="findTicket.codeCaisse" class="mb-4">
                                    <div class="font-light">{{$t('form.recherche-ticket.code_caisse')}}:</div>
                                    <b>{{findTicket.codeCaisse}}</b>
                                </div>
                                <div v-if="findTicket.numeroTicket" class="mb-4">
                                    <div class="font-light">{{$t('form.recherche-ticket.numero_de_ticket_de_caisse')}}:</div><b>{{findTicket.numeroTicket}}</b>
                                    </div>
                                <div v-if="findTicket.shop.townAndZipCode" class="mb-4">
                                    <div class="font-light">{{$t('form.recherche-ticket.magasin')}}:</div>
                                    <b>{{findTicket.shop.townAndZipCode}}</b>
                                </div>
                            </div>
                            <div class="mb-4" v-if="findTicket.device && findTicket.device.description">
                                <label for="get-shop" class="block pb-2 font-light text-gray-600">{{$t('form.recherche-ticket.produit')}}</label>
                                <div class="font-bold text-lg">{{findTicket.device.description}}</div>
                            </div>
                            <div class="mb-4" v-if="findTicket.img_plaque_signaletique && findTicket.img_plaque_signaletique.url">
                                <label for="get-shop" class="block pb-2 font-light text-gray-600">{{$t('form.recherche-ticket.image_de_la_plaque_signaletique')}}</label>
                                <a :href="findTicket.img_plaque_signaletique.url" target="_blank" class="text-sm text-blue-500 hover:underline">
                                    <i class="mr-1 fas fa-link"></i>{{$t('form.recherche-ticket.consulter_le_fichier')}}
                                </a>
                            </div>
                            <button @click="updateFormData" class="px-5 py-2.5 text-sm font-base duration-100 duration-200 bg-gray-300 border-gray-400 rounded-xl" test-id="sav-button">
                                {{$t('form.recherche-ticket.corriger_mes_informations')}} <i class="fas fa-edit ml-1"></i>
                            </button>
                        </template>
                    </template>
                </template>
            </template>
        </sav-fold-card>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

import moment from 'moment'

export default {
    name: 'find-sales-receipt',
    extends: FormCardExtension,

    data() {
        return {
            findTicket: null,
            dateRange: null,
            sign: null,
            shops: [],
            products: null,
            loadingApiTicket: false
        }
    },

    computed: {
        userIsAuth() {
            return this.$crypto.decrypt(localStorage.getItem('client_id'))
        }
    },

    methods: {
        async init() {
            this.loading = true

            await this.getSign()
            this.$formTool.addFormData('buy-online', 'shop')

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.findTicket = {...this.selected}
                if (this.findTicket.hasTicket) {
                    this.confirmHasTicket()
                }
                this.nextBlock = this.getNextRoute()
            } else {
                // Init form data
                this.initFindTicket()
            }

            // Set date range
            this.dateRange = {
                min: moment().subtract(5, 'years').format('YYYY-MM-DD'),
                max: moment().format('YYYY-MM-DD')
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            this.loading = false
        },

        end() {
            let callbackData = this.findTicket
            this.$formTool.addFormData(this.$options.name, callbackData)
            if (this.findTicket.end) {
                this.nextBlock = this.getNextRoute()
            } else {
                this.nextBlock = this.getNextRoute()
            }
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))

            // Set value in localstorage
            if (this.findTicket.shop) {
                this.$formTool.addFormData('shop', [{value: this.findTicket.shop}])
            }
            if (this.findTicket.date) {
                this.$formTool.addFormData('purchase-date', [{value: this.findTicket.date}])
            }
            if (this.findTicket.end) {
                this.$formTool.addFormData('nameplate-picture', this.findTicket.img_plaque_signaletique)
                this.$formTool.addFormData('device', [{value: this.findTicket.device}])
            }
        },

        getNextRoute() {
            if (this.findTicket.end) {
                if (this.userIsAuth) {
                    return this.$formTool.blockData(this.$options.name).next.continue
                } else {
                    return 'login'
                }
            }
            return this.$formTool.blockData(this.$options.name).next.manual
        },

        initFindTicket() {
            this.findTicket = {
                hasTicket: null,
                date: null,
                codeCaisse: null,
                numeroTicket: null,
                shop: null,
                found: null,
                img_plaque_signaletique: null,
                device: null,
                end: null
            }
        },

        async confirmHasTicket() {
            await this.getAllShops()
            this.findTicket.hasTicket = true
        },

        confirmHasnTicket() {
            this.findTicket.hasTicket = false
            this.end()
            this.$formTool.removeFormData('shop')
            this.$formTool.removeFormData('purchase-date')
            this.$formTool.removeFormData('nameplate-picture')
            this.$formTool.removeFormData('device')
        },

        async getSign() {
            let response = await apiService.post('getinfodomain', {})
            this.sign = response.data.posts.post[0]
            this.$formTool.addFormData('sign', this.sign)
        },

        async getAllShops() {
            let response = await apiService.post('getshop', {
                id_enseigne: this.sign.id
            })
            this.shops = response.data.posts.post.map(shop => ({
                ...shop,
                townAndZipCode: this.$addressTool.capitalizeTown(shop.ville) + shop.cp,
                moreData: this.$formTool.blockData(this.$options.name).meta && this.$formTool.blockData(this.$options.name).meta.codeMag ? shop.code_mag : null,
                // img: this.sign.logo_domain
            }))
        },

        async searchApiTicket() {
            if (!this.findTicket.date || !this.findTicket.codeCaisse || !this.findTicket.numeroTicket || !this.findTicket.shop) {
                this.$toast.error(this.$t('form.recherche-ticket.formulaire_incomplet'))
                return
            }
            this.loadingApiTicket = true
            let response = await apiService.postProd('ticket', {
                purchase_date: this.findTicket.date,
                code_caisse: this.findTicket.codeCaisse,
                num_facture: this.findTicket.numeroTicket,
                // code_magasin: this.findTicket.shop.code_mag
                code_magasin: 'CG338'
            })
            if (response.data.posts.post == 0) {
                this.findTicket.found = false
            } else {
                this.findTicket.found = true
                this.products = response.data.posts.post
            }
            this.loadingApiTicket = false
        },

        getManually() {
            this.end()
        },

        searchRetry() {
            this.findTicket.found = {...this.findTicket}
            this.findTicket.found = null
        },

        sendFiles() {
            if (!this.findTicket.img_plaque_signaletique) {
                this.$toast.error(this.$t('form.recherche-ticket.formulaire_incomplet'))
                return
            }
            this.findTicket.end = true
            this.end()
        },

        updateFormData() {
            this.findTicket.found = null
            this.findTicket.end = null
            this.findTicket.device = null
            this.findTicket.hasTicket = null
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/shop/FindSalesReceipt.vue